import React from 'react'

interface PaginationLink {
  url: string | null
  label: string
  active: boolean
}

interface PaginationData {
  current_page: number
  from: number | null
  to: number | null
  total: number
  last_page: number
  prev_page_url: string | null
  next_page_url: string | null
  links: PaginationLink[]
}

interface PaginationProps {
  paginationData: PaginationData
  onPageChange: (page: number) => void
  onPrevPage: () => void
  onNextPage: () => void
  loading?: boolean
  className?: string
}

const Pagination: React.FC<PaginationProps> = ({
  paginationData,
  onPageChange,
  onPrevPage,
  onNextPage,
  loading = false,
  className = '',
}) => {
  if (!paginationData || paginationData.total === 0) {
    return null
  }

  return (
    <div className={`row mt-4 ${className}`}>
      <div className="col-md-6">
        <div className="dataTables_info">
          Showing {paginationData.from || 0} to {paginationData.to || 0} of{' '}
          {paginationData.total} entries
        </div>
      </div>
      <div className="col-md-6">
        <nav aria-label="Page navigation">
          <ul className="pagination justify-content-end mb-0">
            {/* Previous Button */}
            <li
              className={`page-item ${
                !paginationData.prev_page_url || loading ? 'disabled' : ''
              }`}
            >
              <button
                className="page-link"
                onClick={onPrevPage}
                disabled={!paginationData.prev_page_url || loading}
                aria-label="Previous"
              >
                <span aria-hidden="true">&laquo;</span>
              </button>
            </li>

            {/* Page Numbers */}
            {paginationData.links
              .filter(
                (link) =>
                  link.label !== '&laquo; Previous' &&
                  link.label !== 'Next &raquo;',
              )
              .map((link, index) => {
                const pageNum = parseInt(link.label)
                const isEllipsis = link.label === '...'

                return (
                  <li
                    key={index}
                    className={`page-item ${link.active ? 'active' : ''} ${
                      isEllipsis || loading ? 'disabled' : ''
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() =>
                        !isEllipsis && !loading && onPageChange(pageNum)
                      }
                      disabled={!link.url || isEllipsis || loading}
                    >
                      {link.label}
                    </button>
                  </li>
                )
              })}

            {/* Next Button */}
            <li
              className={`page-item ${
                !paginationData.next_page_url || loading ? 'disabled' : ''
              }`}
            >
              <button
                className="page-link"
                onClick={onNextPage}
                disabled={!paginationData.next_page_url || loading}
                aria-label="Next"
              >
                <span aria-hidden="true">&raquo;</span>
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  )
}

export default Pagination
